<input
  class="form-check-input cursor-pointer quiz-check-input"
  type="checkbox"
  role="switch"
  aria-label="coaching-sessions-page-me-mode"
  [(ngModel)]="localStatus"
  (change)="handleQuizAnswer($event)" />
